import IValidationHttpErrorResponse from '../../interfaces/BadRequest/IValidationHttpErrorResponse';
import BadRequestHttpError from '../BadRequestHttpError';

export default class ValidationHttpError extends BadRequestHttpError<IValidationHttpErrorResponse> {
    constructor(response: IValidationHttpErrorResponse) {
        super('Validation error!', response);
    }
}
